"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeleteNotification = useDeleteNotification;
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _headers = require("../constants/headers");
var _logger = require("../logger");
var _isOnBehalf = require("../utils/isOnBehalf");
var _withHandePost = require("../utils/withHandePost");
var _useRestoreNotification = require("./useRestoreNotification");
const isDevelopment = process.env.NODE_ENV === 'development';
const logger = _logger.mainLogger.createChild('useNotificationDeleteQuery');
function useDeleteNotification() {
  const {
    token,
    customerId
  } = (0, _auth.useToken)();
  const client = (0, _globalApiClientReact.useApiClient)();
  const [lastDeletedNotification, setLastDeletedNotification] = (0, _react.useState)();
  const [/** Current error for the last mutation */
  error, setError] = (0, _react.useState)();
  const [restoreNotification] = (0, _useRestoreNotification.useRestoreNotification)();
  const mutate = (0, _react.useCallback)(async notification => {
    const onBehalf = (0, _isOnBehalf.isOnBehalf)(token);
    // Delete previous error so user is not confused
    setError(undefined);
    if (!isDevelopment && onBehalf || notification.notificationId === undefined) {
      return true;
    }
    return (0, _withHandePost.withHandlePost)((0, _globalApiClientReact.deleteCustomerInAppNotification)(client, customerId, notification.notificationId, {
      [_headers.HEADER_KEY_X_CLIENT_APPLICATION]: _headers.HEADER_VALUE_X_CLIENT_APPLICATION
    }), {
      onError(currentError) {
        logger.error(new Error('Failed to delete notification', {
          cause: currentError
        }));
        setError(currentError);
      }
    }).then(didDelete => {
      if (didDelete) {
        setLastDeletedNotification(notification);
      }
      return didDelete;
    });
  }, [client, customerId, token]);

  /** Restores last deleted notification if any */
  const restore = (0, _react.useCallback)(async () => {
    if (!lastDeletedNotification) {
      return true;
    }
    const didDelete = await restoreNotification(lastDeletedNotification);
    if (didDelete) {
      setLastDeletedNotification(undefined);
    }
    return didDelete;
  }, [lastDeletedNotification, restoreNotification]);

  /** Last successfully deleted notification */
  const data = lastDeletedNotification;
  /** Clears data */
  const clear = (0, _react.useCallback)(() => {
    setLastDeletedNotification(undefined);
    setError(undefined);
  }, []);
  return [mutate, {
    data,
    clear,
    restore,
    error
  }];
}
